import React, { FC } from "react";
import queryString from "query-string";
import LocalStorageKeys from "Shared/Constants/LocalStorageKeys";

const LoginHandler: FC = ({ children }) => {
  const urlFragment = queryString.parse(window.location.hash);
  // Store token in local storage
  const storeToken = (key: string, value: string | undefined) => {
    if (value) {
      localStorage.setItem(key, value);
    }
  };

  // Fetch tokens if they are present in the fragment
  const token = urlFragment.access_token as string | undefined;
  const deviceToken = urlFragment.device_token as string | undefined;
  storeToken(LocalStorageKeys.userTokenKey, token);
  storeToken(LocalStorageKeys.deviceTokenKey, deviceToken);

  return <>{children}</>;
};

export default LoginHandler;
